import React from "react";
import { CompanySummary } from "../model/company_management_model";

interface CompanyManagementSummaryCardsProps {
  total: number;
  summary: CompanySummary;
}

const renderSummaryCard = (
  label: string,
  value: number,
  valueClassName = "text-gray-900",
) => (
  <div className="rounded-lg border bg-white p-4 shadow">
    <div className="text-sm font-medium text-gray-500">{label}</div>
    <div className={`text-2xl font-bold ${valueClassName}`}>
      {value.toLocaleString()}
    </div>
  </div>
);

const CompanyManagementSummaryCards: React.FC<
  CompanyManagementSummaryCardsProps
> = ({ total, summary }) => (
  <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-6">
    {renderSummaryCard("Matched Companies", total)}
    {renderSummaryCard("Active", summary.total_active, "text-green-600")}
    {renderSummaryCard("Past Due", summary.total_past_due, "text-yellow-600")}
    {renderSummaryCard("Expired", summary.total_expired, "text-red-600")}
    {renderSummaryCard("Trial", summary.total_trial, "text-blue-600")}
    {renderSummaryCard("Cancelled", summary.total_cancelled, "text-gray-700")}
  </div>
);

export default CompanyManagementSummaryCards;
